import { render, staticRenderFns } from "./ExpenseItems.vue?vue&type=template&id=a5bfa772"
import script from "./ExpenseItems.vue?vue&type=script&lang=js"
export * from "./ExpenseItems.vue?vue&type=script&lang=js"
import style0 from "./ExpenseItems.vue?vue&type=style&index=0&id=a5bfa772&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports